import { render, staticRenderFns } from "./TaskGroupsDeleteDialog.vue?vue&type=template&id=4e16ee7c&"
import script from "./TaskGroupsDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./TaskGroupsDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports